import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  uploads: {},
  isLoading: false,
  error: null
};

const uploadsSlice = createSlice({
  name: 'uploads',
  initialState,
  reducers: {
    uploadStarted: (state, action) => {
      const { fileId, fileName, fileSize, fileType, source, uploadId } = action.payload;
      state.uploads[fileId] = {
        fileId,
        fileName,
        fileSize,
        fileType,
        source,
        uploadId,
        progress: 0,
        status: 'started',
        completedParts: [],
        startedAt: new Date().toISOString()
      };
    },
    uploadProgress: (state, action) => {
      const { fileId, progress, completedParts } = action.payload;
      if (state.uploads[fileId]) {
        state.uploads[fileId].progress = progress;
        state.uploads[fileId].status = 'in_progress';
        if (completedParts) {
          state.uploads[fileId].completedParts = completedParts;
        }
      }
    },
    uploadCompleted: (state, action) => {
      const { fileId, s3Url } = action.payload;
      if (state.uploads[fileId]) {
        state.uploads[fileId].status = 'completed';
        state.uploads[fileId].progress = 100;
        state.uploads[fileId].s3Url = s3Url;
        state.uploads[fileId].completedAt = new Date().toISOString();
      }
    },
    uploadFailed: (state, action) => {
      const { fileId, error } = action.payload;
      if (state.uploads[fileId]) {
        state.uploads[fileId].status = 'failed';
        state.uploads[fileId].error = error;
      }
    },
    removeUpload: (state, action) => {
      const { fileId } = action.payload;
      delete state.uploads[fileId];
    },
    clearAllUploads: (state) => {
      state.uploads = {};
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    }
  }
});

export const {
  uploadStarted,
  uploadProgress,
  uploadCompleted,
  uploadFailed,
  removeUpload,
  clearAllUploads,
  setError,
  clearError
} = uploadsSlice.actions;

// Selectors
export const selectAllUploads = (state) => Object.values(state.uploads.uploads);
export const selectUploadById = (state, fileId) => state.uploads.uploads[fileId];
export const selectInProgressUploads = (state) => 
  Object.values(state.uploads.uploads).filter(
    upload => upload.status === 'started' || upload.status === 'in_progress'
  );
export const selectCompletedUploads = (state) => 
  Object.values(state.uploads.uploads).filter(upload => upload.status === 'completed');
export const selectFailedUploads = (state) => 
  Object.values(state.uploads.uploads).filter(upload => upload.status === 'failed');
export const selectUploadError = (state) => state.uploads.error;

export default uploadsSlice.reducer; 